import { gql } from '@apollo/client'

export const GET_COMPANY_V2 = gql`
  query GetCompanyV2($companyId: UUID!) {
    companyV2(id: $companyId) {
      id
      name
      phone
      vertical
      policy {
        id
        name
      }
      address {
        line1
        line2
        cityName
        stateCode
        countryCode
        zipCode
      }
      comments
    }
  }
`

export const GET_COMPANIES_V2 = gql`
  query GetCompaniesV2($limit: Int!, $page: Int!) {
    companiesV2(pagination: { size: $limit, page: $page }) {
      total
      items {
        id
        name
        phone
        vertical
        policy {
          id
          name
        }
        address {
          line1
          line2
          cityName
          stateCode
          countryCode
          zipCode
        }
      }
    }
  }
`

export const COMPANY_SUGGESTION_FRAGMENT = gql`
  fragment CompanySuggestionFragment on CompanySuggestion {
    id
    name
    vertical
  }
`

export const GET_COMPANIES_SUGGESTIONS = gql`
  query GetCompaniesSuggestions($input: CompanySuggestionsInput!) {
    companySuggestions(input: $input) {
      total
      items {
        ...CompanySuggestionFragment
      }
    }
  }
  ${COMPANY_SUGGESTION_FRAGMENT}
`
